<template>
  <div
    class="org-List"
    :class="{
      'h5-org-List': isH5,
      'web-org-list': !isH5,
      'electron-org-list': isElectron,
    }"
  >
    <p class="module-title">推荐机构</p>
    <div class="org-list-wrap">
      <div v-for="org in showOrgList" :key="org.id">
        <!-- 机构卡片 -->
        <div class="org-item" v-if="org.course_list && org.course_list.length">
          <!-- 机构信息 -->
          <div class="basic-info" @click="jumpUrl(`/org/${org.org.org_id}`)">
            <img class="logo" :src="handlerOrgLogo(org.org.org_logo)" alt="" />
            <div class="org-data">
              <p class="name">
                {{ org.org.org_name }}
              </p>
              <p class="desc">
                {{ org.org.org_desc }}
              </p>
              <!-- 数据展示 -->
              <div
                v-if="false && org.student_count_show === 1"
                class="data-STATS"
              >
                <span>课程总数 {{ million(org.course_count) }}</span>
                <span>服务学生数 {{ million(org.student_count) }}</span>
              </div>
            </div>
          </div>
          <div class="item-bottom">
            <!-- 介绍 -->
            <div v-if="false" class="desc-wrap">
              <div class="desc" v-show="org.org.org_desc">
                <img src="../../../assets/images/home/info-icon.png" alt="" />
                <p>{{ org.org.org_desc }}</p>
              </div>
            </div>
            <OrgCourseCard :courseInfo="org.course_list[0]" />
          </div>
          <!-- 操作 -->
          <!-- <div class="operate-wrap">
            <button @click="handleClickAllCourse(org.org.org_id)">
              查看全部课程
            </button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { million } from "@saas/components/src/utils/utils";
import { isH5, isMobile } from "@saas/components/src";
import OrgCourseCard from "./OrgCourseCard.vue";
import { mapGetters } from "vuex";
export default {
  props: {
    orgList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: function () {
    return {
      million,
      isMobile: isMobile(),
      isH5: isH5(),
      isElectron: window.isElectron,
    };
  },
  methods: {
    jumpUrl(url) {
      if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    handleClickAllCourse(org_id) {
      if (this.$router.query && this.$router.query.inReview === "1") {
        this.jumpUrl(`/org-courses/${org_id}?inReview=1`);
      } else {
        this.jumpUrl(`/org-courses/${org_id}`);
      }
    },
    handlerOrgLogo(url) {
      if (!url) {
        return `https://cdn.comettech.com/cdn/static/images/default_org_logo.png?imageView2/0/w/100`;
      } else {
        return url + "?imageView2/0/w/100";
      }
    },
  },
  components: {
    OrgCourseCard,
  },
  watch: {},
  computed: {
    ...mapGetters(["user"]),
    showOrgList() {
      return this.orgList.filter((item) => {
        return item.course_list?.length;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.org-List {
  padding-top: 16px;
  padding-bottom: 0;
  .org-list-wrap {
    display: flex;
    flex-wrap: wrap;
  }

  .org-list-wrap > div:nth-child(3n) .org-item {
    margin-right: 0;
  }
  //机构卡片
  .org-item {
    &:hover {
      transform: translateY(-5px);
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;
      box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
      // .operate-wrap {
      //   pointer-events: auto;
      //   opacity: 1;
      //   transition: all 0.3s ease;
      // }
      // .basic-info .name {
      //   color: $saas-theme-color;
      // }
    }
    display: flex;
    flex-direction: column;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    position: relative;
    cursor: pointer;
    width: 380px;
    height: 446px;
    background: #ffffff;
    border-radius: 24px;
    margin: 0 30px 30px 0;
    // .operate-wrap {
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    //   pointer-events: none;
    //   transition: all 0.3s ease;
    //   opacity: 0;
    //   position: absolute;
    //   bottom: 0;
    //   left: 10px;
    //   width: 365px;
    //   height: 90px;
    //   background: linear-gradient(
    //     180deg,
    //     rgba(255, 255, 255, 0.44) 0%,
    //     #ffffff 100%
    //   );
    //   backdrop-filter: blur(1px);
    //   button {
    //     width: 144px;
    //     height: 40px;
    //     background: #ffffff;
    //     border-radius: 4px;
    //     border: 1px solid $saas-theme-color;
    //     font-size: 14px;
    //     color: $saas-theme-color;
    //     line-height: 20px;
    //   }
    // }
    // 机构信息
    .basic-info {
      background: #fafafa;
      border-radius: 24px 24px 0px 0px;
      width: 100%;
      height: 96px;
      display: flex;
      padding: 0 12px;
      align-items: center;
      .logo {
        width: 70px;
        height: 70px;
        border-radius: 16px;
        border: 1px solid #e2e2e2;
        margin-right: 6px;
        object-fit: cover;
        margin-right: 12px;
      }
      .org-data {
        flex: 1;
        width: 0;
        height: 70px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .name {
        font-weight: 500;
        font-size: 18px;
        color: #000000;
        line-height: 25px;
        margin-bottom: 2px;
        line-break: anywhere;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .desc {
        font-size: 14px;
        color: #515350;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-break: anywhere;
      }
      .data-STATS {
        font-size: 14px;
        color: $plain-text-color;
        line-height: 20px;
        span:first-child {
          margin-right: 53px;
        }
      }
    }
    .item-bottom {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 12px 12px 20px;
      // 介绍
      .desc-wrap {
        height: 34px;
        margin-bottom: 16px;
      }
      .desc {
        display: flex;
        img {
          width: 10px;
          height: 10px;
          margin-right: 4px;
        }
        p {
          flex: 1;
          font-size: 12px;
          color: $plain-text-color;
          line-height: 17px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }
  }
}

// 客户端
.electron-org-list.org-List {
  .org-item {
    width: 314px;
    height: 325px;
    border-radius: 12px;
    margin: 0 19px 19px 0;
    .basic-info {
      border-radius: 12px 12px 0px 0px;
      height: 68px;
      padding: 0 12px;
      .logo {
        width: 50px;
        height: 50px;
        border-radius: 12px;
        margin-right: 8px;
      }
      .org-data {
        flex: 1;
        width: 0;
        height: 54px;
      }
      .name {
        margin-bottom: 3px;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 0;
      }
      .desc {
        font-size: 12px;
        line-height: 17px;
      }
      .data-STATS {
        font-size: 12px;
        line-height: 17px;
      }
    }
    .item-bottom {
      padding: 10px 14px;
      .desc-wrap {
        height: 34px;
        margin-bottom: 10px;
      }
      .desc {
        img {
          width: 10px;
          height: 10px;
          margin-right: 8px;
        }
      }
    }
  }
}

// h5
.h5-org-List.org-List {
  padding: 0.23rem 0.32rem 0;
  .org-list-wrap .org-item {
    margin: 0 auto 0.2rem;
  }

  //机构卡片
  .org-item {
    &:hover {
      transform: none;
      -webkit-transition: none;
      transition: none;
    }
    -webkit-transition: none;
    transition: none;
    width: 100%;
    height: 9.89rem;
    border-radius: 0.43rem;
    padding: 0.32rem 0.32rem 0;
    // 机构信息
    .basic-info {
      border-radius: 0.21rem;
      width: 100%;
      height: auto;
      padding: 0.21rem;
      .logo {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 0.21rem;
        border: 0.01rem solid #e2e2e2;
        margin-right: 0.16rem;
      }
      .name {
        font-weight: 500;
        font-size: 0.4rem;
        color: #0d1400;
        line-height: 0.56rem;
        margin-bottom: 0.13rem;
      }
      .data-STATS {
        font-weight: 400;
        font-size: 0.29rem;
        color: #515350;
        line-height: 0.4rem;
        span:first-child {
          margin-right: 0.4rem;
        }
      }
    }
    .item-bottom {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin: 0;
      padding: 0;
      // 介绍
      .desc-wrap {
        height: 0.8rem;
        margin: 0.21rem;
      }
      .desc {
        display: flex;
        img {
          position: relative;
          width: 0.16rem;
          height: 0.16rem;
          margin-right: 0.08rem;
        }
        p {
          flex: 1;
          font-weight: 400;
          font-size: 0.29rem;
          color: #515350;
          line-height: 0.4rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }
  }
}
</style>
